/**
 * Gear Image Resolution Utility
 * Mirrors player image resolution pattern for architectural consistency.
 * 
 * Pattern reference: ExpandablePlayerCard.js line 274
 */

/**
 * Resolve gear image URL with fallback to default mystery item.
 *
 * @param {Object} gear - Gear object from API (must have item_id)
 * @returns {string} - Resolved image path
 */
export const getGearImageUrl = (gear) => {
    // Construct path from item_id if available
    if (gear?.item_id) {
        return `/art/gear_images/${gear.item_id}.png`;
    }

    // Fallback to default mystery item
    return '/art/mystery-item2.png';
};

/**
 * Handle image load errors by falling back to default.
 * Use as onError handler on <img> tags.
 * 
 * @param {Event} e - Image error event
 */
export const handleGearImageError = (e) => {
    if (e.target.src !== '/art/mystery-item2.png') {
        e.target.onerror = null; // Prevent infinite loop
        e.target.src = '/art/mystery-item2.png';
    }
};
